import $ from 'jquery';
import Cookies from 'js-cookie';
import oldBrowserCheck from '@spinnwerk/old-browser-check';

export default function({
    selector      = '.browser-alert--browsehappy',
    closeSelector = '.js-close-browser-alert-info',
    cookieName    = 'oldBrowserInfo',
    GA            = null
} = {}) {
    var $element = $(selector),
        oldBrowser     = oldBrowserCheck({
            ie: '11',
            firefox: '40',
            chrome: '40',
            opera: '31',
            safari: '8',
            android: '4.4'
        });

    // stores a cookie for the current session of the browser
    function storeCookie() {
        Cookies.set(cookieName, true);
    }

    // if the cookie doesn't exist yet, show the info
    if (oldBrowser && Cookies.get(cookieName) === undefined) {
        $element.show();

        // init the close click to fade out the element
        $(closeSelector).click(function(event) {
            event.preventDefault();
            storeCookie();
            $element.fadeOut();
        });
    }

    function trackOldBrowser() {
        if (GA && GA.event) {
            GA.event('Systemalert', 'Browserversion', document.documentElement.getAttribute('data-browser'), 1);
        }
    }

    if (oldBrowser === true) {
        trackOldBrowser();
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/lib/alerts/old-browser.js